import { ComponentRef } from '@angular/core';
import { Exclude, Expose, Transform, Type } from 'class-transformer';
import { ITimeBlockViewType } from '../../../features/calendar/components/time-block/types/time-block-types';
import { DateTimeHelper } from '../../../features/calendar/util/date-time-helper';
import { TodoEntryComponent } from '../../../features/todo-planner/todo-entry/todo-entry.component';
import { ICanBeOrdered } from '../../../shared/functions/array-functions';
import { Priorities } from '../../constants-repository/priority-values.constants';
import { FileNameModel } from '../file/file-name.model';

export class TodoEntryModel implements ICanBeOrdered {
  @Exclude({ toPlainOnly: true })
  public id = -1;
  public name = '';

  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public start = new Date();

  @Transform(({ value }) => DateTimeHelper.format(value), { toPlainOnly: true })
  @Transform(({ value }) => new Date(value), { toClassOnly: true })
  public end = new Date();

  public color = '';

  public priority = Priorities.Low;

  public order = -1;

  public description = '';

  public completed = false;

  @Expose({ name: 'project_id' })
  public projectId: null | number = null;

  @Expose({ name: 'is_public' })
  public isPublic = false;

  @Expose({ name: 'user_id' })
  public userId = -1;

  @Expose({ name: 'fix_interval' })
  public fixInterval: boolean = false;

  @Type(() => FileNameModel)
  public attachments: FileNameModel[] = [];

  @Exclude()
  public componentRef: ComponentRef<TodoEntryComponent> = null;

  @Exclude()
  public timeBlockViewType: ITimeBlockViewType = null;

  @Exclude()
  public reRenderComponent = true;
}
